/** Figma: Confirm or Refine Interpretation — chip keys map to API via buildFrameworkRoutePayload. */

export const PRIMARY_ISSUE_TYPE_KEYS = [
  'pricingRevenue',
  'growthStrategy',
  'operations',
  'orgStructure',
  'marketCompetition',
] as const;

export const PRIMARY_CONSTRAINT_KEYS = [
  'conversionInefficiency',
  'costPressure',
  'executionGaps',
  'misalignedIncentives',
  'other',
] as const;

export const INTERPRETATION_CONFIDENCE_KEYS = ['high', 'moderate', 'low'] as const;

export type PrimaryIssueTypeKey = (typeof PRIMARY_ISSUE_TYPE_KEYS)[number];
export type PrimaryConstraintKey = (typeof PRIMARY_CONSTRAINT_KEYS)[number];
export type InterpretationConfidenceKey = (typeof INTERPRETATION_CONFIDENCE_KEYS)[number];
